import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-hrm-header',
  templateUrl: './hrm-header.component.html'
})
export class HrmHeaderComponent implements OnInit {
  @Input() hideCompanyDropdown = false;
  @Input() hideModuleSelector = false;
  @Input() hideBorder = false;
  @Input() searchPlaceholder = 'Tìm kiếm ứng dụng';
  @Input() logoUrl = 'https://exit-binary-24897316.figma.site/_assets/v11/4a9cf86e13f0f5a9908e44a9d0f224dd88654a9a.png';

  @Output() menuClick = new EventEmitter<void>();
  @Output() logout = new EventEmitter<void>();
  @Output() navigateToModules = new EventEmitter<void>();

  isModuleDropdownOpen = false;
  isUserMenuOpen = false;
  isLanguageDropdownOpen = false;
  isMobileSearchOpen = false;
  currentLanguage: string;
  isDarkMode: boolean;

  userName = 'Admin User';
  userEmail = 'dev_admin@company.com';
  avatarUrl = '';
  defaultAvatarUrl = 'https://lh3.googleusercontent.com/aida-public/AB6AXuCk6_hTUPlyZOndSGJkzdG0wMldTZ48Ph4drpXh8wt9Lh4vqg-N3WqX2z3_tOwMYzJnQB7r0jx44yKkxGMcnC8h45SBqevnY18xWx48HPPmodTOJtizJE8iNlniTHiw1yl8m0MPdNVHYCQZB12ro0iPSqVlP8ElTdEXuK42Yo2fPbk0GkAiG0EQRJmZg3bmhEr_e5D_Bt0w5y20vR8XjI3M64A7FpKWwlSkK9ISdiS4Sjn92Pzml_1Vm0xcNoV7ziC-KpwzmfDX1w';

  constructor(
    private router: Router,
    private auth: AuthService,
    private oauthService: OAuthService
  ) {
    const savedLang = typeof localStorage !== 'undefined' ? localStorage.getItem('language') : null;
    this.currentLanguage = savedLang || 'vi';
    const savedTheme = typeof localStorage !== 'undefined' ? localStorage.getItem('theme') : null;
    this.isDarkMode = savedTheme === 'dark';
    this.applyTheme();
  }

  ngOnInit(): void {
    this.userName = this.auth.getUserName();
    this.userEmail = this.auth.getEmail();
    this.avatarUrl = this.auth.getUserImage();
  }

  private applyTheme(): void {
    if (typeof document === 'undefined') return;
    if (this.isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }

  onMenuClick(): void {
    this.menuClick.emit();
  }

  goToHome(): void {
    this.router.navigate(['/home']);
  }

  toggleTheme(): void {
    this.isDarkMode = !this.isDarkMode;
    this.applyTheme();
  }

  toggleMobileSearch(): void {
    this.isMobileSearchOpen = !this.isMobileSearchOpen;
  }

  toggleLanguageDropdown(): void {
    this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
  }

  toggleModuleDropdown(): void {
    this.isModuleDropdownOpen = !this.isModuleDropdownOpen;
  }

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  changeLanguage(lang: string): void {
    this.currentLanguage = lang;
    localStorage.setItem('language', lang);
    this.isLanguageDropdownOpen = false;
  }

  onNavigateToModulesClick(): void {
    this.isModuleDropdownOpen = false;
    this.navigateToModules.emit();
  }

  onLogoutClick(): void {
    this.isUserMenuOpen = false;
    this.oauthService.revokeTokenAndLogout({
      client_id: this.oauthService.clientId,
      returnTo: this.oauthService.redirectUri
    }, true);
    this.logout.emit();
  }
}
